// Avatars, age/plan labels and weekday names.
import { moduleLang } from "../i18n.jsx";
import { toFa } from "./format.js";

// ── Avatar emoji sets ─────────────────────────────────────────────────────────
export const AVATAR_FAVORITES = ["🦁", "🦊", "🚀", "🌈", "🦋", "⭐", "🐬", "🐱"];
export const AVATAR_ALL = [
  "🦁","🦊","🚀","🌈","🦋","⭐","🐬","🐱",
  "🐶","🐰","🐻","🐼","🐨","🐯","🦄","🐸",
  "🐢","🐙","🦕","🦖","🐳","🦈","🦜","🦩",
  "🐝","🐥","⚡","🔥","🐧","🐠","🚂","🦇",
  "🤖","🦀","🦔","🦑","🐮","🐷","🐵","🦥",
  "🦸","🧚","🧜","🧙","🐲","🦞","🐡","🦧",
  "🐺","🦝",
];

// ── Age range display helpers ────────────────────────────────────────────────
export const AGE_DISPLAY = { "3-4": "۳-۴ ساله", "5-6": "۵-۶ ساله", "7-8": "۷-۸ ساله", "9-10": "۹-۱۰ ساله" };
export const AGE_TO_API = { "۳-۴ ساله": "3-4", "۵-۶ ساله": "5-6", "۷-۸ ساله": "7-8", "۹-۱۰ ساله": "9-10" };
export const AGE_DISPLAY_EN = { "3-4": "3–4 yrs", "5-6": "5–6 yrs", "7-8": "7–8 yrs", "9-10": "9–10 yrs" };
export const PLAN_LABELS = { 1: "۱ ماهه", 2: "۲ ماهه", 3: "۳ ماهه" };
export const PLAN_LABELS_EN = { 1: "1 month", 2: "2 months", 3: "3 months" };
// Language-aware display helpers (fall back to the raw value / Persian).
export const ageLabel  = (r) => (moduleLang() === "fa" ? AGE_DISPLAY : AGE_DISPLAY_EN)[r] || r;
// The EXACT age (2026-10-05). Ages offered on the add-child page; the range is
// derived from it server-side, so it must stay inside the product's 3–10 band.
export const AGES = [3, 4, 5, 6, 7, 8, 9, 10];
export const ageBucket = (a) => { const lo = a % 2 ? a : a - 1; return `${lo}-${lo + 1}`; };
export const exactAgeLabel = (a) => (moduleLang() === "fa" ? `${toFa(a)} ساله` : `${a} yrs`);
// A child's age for display: the exact age when we have it, else the old range.
export const childAgeLabel = (c) => (c?.age ? exactAgeLabel(c.age) : ageLabel(c?.age_range));
export const planLabel = (m) => (moduleLang() === "fa" ? PLAN_LABELS : PLAN_LABELS_EN)[m] || (moduleLang() === "fa" ? `${toFa(m)} ماهه` : `${m} months`);
export const fmtDate   = (d) => new Date(d).toLocaleDateString(moduleLang() === "fa" ? "fa-IR" : "en-GB");

// ── Day / time helpers ────────────────────────────────────────────────────────
export const DAY_FA = ["شنبه","یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنج‌شنبه","جمعه"];
export const DAY_EN = ["Saturday","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday"];
// Weekday names per language — add a row when you add a language (falls back to fa).
export const DAY_NAMES = { fa: DAY_FA, en: DAY_EN };
export function dayName(idx) { return (DAY_NAMES[moduleLang()] || DAY_FA)[idx]; }
// Map our day index (0=Saturday) to JS getDay() (0=Sunday)
export const OUR_TO_JS = { 0:7, 1:0, 2:1, 3:2, 4:3, 5:4, 6:5 }; // saturday=7 mod7=0 trick below

